<template>
    <div class="wrap">
        <div>
            <Banner></Banner>
        </div>
        <div class="content">
            <div class="bar">
                <label>{{name}}</label>
                <span></span>
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_star.png">
            </div>

            <div class="timeline">
                <div class="item">
                      <label class="line"></label>
                      <span :class="star.phase==1?'highlight':''">{{line_1}}</span>
                      <label class="dot"></label>
                      <label class="btn light" @click="toSurvey(1)" v-if="star.phase==1">编辑</label>
                      <label class="btn" v-else>编辑</label>
                </div>
                    <div class="item" v-if="exa!=2">
                        <label class="line"></label>
                        <span :class="(star.phase>=2&&(star.caseVerify==0||star.caseVerify==-1))?'highlight':''">{{line_2}}</span>
                        <label class="dot"></label>
                        <label class="btn light" @click="toCase(0)" v-if="star.phase>=2&&(star.caseVerify==0||star.caseVerify==-1)">{{caseName(star)}}</label>
                        <label class="btn" v-else>{{caseName(star)}}</label>
                    </div>
                    <div class="item" v-if="exa!=2">
                        <label class="line"></label>
                        <span  :class="(star.phase>=2&&(star.videoVerify==0||star.videoVerify==-1))?'highlight':''">{{line_3}}</span>
                        <label class="dot"></label>
                        <label class="btn light" @click="toVideo(0)"   v-if="star.phase>=2&&(star.videoVerify==0||star.videoVerify==-1)">{{videoName(star)}}</label>
                        <label class="btn" v-else>{{videoName(star)}}</label>
                    </div>
                    <div class="item" v-if="exa==2">
                        <label class="line"></label>
                        <span :class="(star.phase>=2&&(star.caseVerify==0||star.caseVerify==-1))?'highlight':''">{{line_2_1}}</span>
                        <label class="dot"></label>
                        <label class="btn light" @click="toCase(0)" v-if="star.phase>=2&&(star.caseVerify==0||star.caseVerify==-1)">{{caseName(star)}}</label>
                        <label class="btn" v-else>{{caseName(star)}}</label>
                    </div>
                    <div class="item" v-if="exa==2">
                        <label class="line"></label>
                        <span  :class="(star.phase>=2&&(star.videoVerify==0||star.videoVerify==-1))?'highlight':''">{{line_3_1}}</span>
                        <label class="dot"></label>
                        <label class="btn light" @click="toVideo(0)"   v-if="star.phase>=2&&(star.videoVerify==0||star.videoVerify==-1)">{{videoName(star)}}</label>
                        <label class="btn" v-else>{{videoName(star)}}</label>
                    </div>
                    <div class="item" v-if="exa==2">
                        <label class="line"></label>
                        <span :class="(caseEnable==1)?'highlight':''">{{line_2_2}}</span>
                        <label class="dot"></label>
                        <label class="btn light" @click="toCase(1)" v-if="caseEnable==1">{{exaCaseName}}</label>
                        <label class="btn" v-else>{{exaCaseName}}</label>
                    </div>
                    <div class="item" v-if="exa==2">
                        <label class="line"></label>
                        <span  :class="(videoEnable==1)?'highlight':''">{{line_3_2}}</span>
                        <label class="dot"></label>
                        <label class="btn light" @click="toVideo(1)"   v-if="videoEnable==1">{{exaVideoName}}</label>
                        <label class="btn" v-else>{{exaVideoName}}</label>
                    </div>
                <div class="item">
                    <label class="line"></label>
                    <span  :class="star.phase==4?'highlight':''">{{line_4}}</span>
                    <label class="dot"></label>
                    <label class="btn light" @click="toSurvey(2)" v-if="star.phase==4">编辑</label>
                    <label class="btn" v-else>编辑</label>
                </div>
                <div class="item">
                    <label class="line"></label>
                    <span   :class="star.phase>4?'highlight':''">{{line_5}}</span>
                    <label class="dot"></label>
                    <label class="btn light" @click="toInfo" v-if="star.phase>4">编辑</label>
                    <label class="btn" v-else>编辑</label>
                </div>
                <div class="item">
                    <label class="line"></label>
                    <span  :class="star.phase>4?'highlight':''">{{line_6}}</span>
                    <label class="dot"></label>
                    <label class="btn light" @click="dialogShow=true" v-if="star.phase>4">查看</label>
                    <label class="btn" v-else>编辑</label>
                </div>
            </div>

        </div>

        <div class="pay" v-if="dialogShow">
            <div class="close" @click="close()">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_close.png">
            </div>
            <div class="icon">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/success.png" v-if="payTime!=null&&payTime!=''">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/fail.png" v-else>
            </div>
            <div class="payStation">
                    <label v-if="payTime==null||payTime==''">未付款</label>
                    <label v-else style="color: #2c9a58">已付款</label>
            </div>
            <div class="payInfo">
                <div class="line">
                    <label>付款日期</label>
                    <span>{{payTime}}</span>
                </div>
                <div class="line">
                    <label>付款单位</label>
                    <span>{{payCompany}}</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {ksdDocGetStar,ksdDocPayStation,ksdDocExaNumber,ksdDocExaStation} from "@/assets/js/api";
    import Banner from "@/components/ksd/fragment/Banner";
    export default {
        name:"docStar",
        components:{
          Banner
        },
        data(){
            return{
                name: '达标之星',
                rule:"查看活动规则",
                line_1:"第一次观念调查",
                line_2:"上传病例报告",
                line_2_1:"上传病例报告1",
                line_2_2:"上传病例报告2",
                line_3:"上传心得体会视频",
                line_3_1:"上传心得体会视频1",
                line_3_2:"上传心得体会视频2",
                line_4:"第二次观念调查",
                line_5:"填写账户信息",
                line_6:"查询付款状态",
                payTime:null,
                payCompany:null,
                dialogShow:false,
                docId:this.$store.state.ksd_docId,
                phase:0,
                star:{
                    phase:0
                },
                exa:this.$route.query.exa,
                exaCaseName:"编辑",
                exaVideoName:"编辑",
                caseEnable:0,
                videoEnable:0
            }
        },
        methods:{
            caseName(star){
                //上传，审核中，审核通过，审核失败
                if(star.caseWork==null||star.caseWork==""){
                    return "编辑"
                }else if(star.caseVerify==0){
                    return "审核中"
                }
                else if(star.caseVerify==-1){
                    return "审核失败"
                }else{
                    return "审核通过"
                }
            },
            videoName(star){
                //上传，审核中，审核通过，审核失败
                if(star.video==null||star.video==""){
                    return "编辑"
                }else if(star.videoVerify==0){
                    return "审核中"
                }
                else if(star.videoVerify==-1){
                    return "审核失败"
                }else{
                    return "审核通过"
                }
            },
            toSurvey(phase){
                this.$router.push({path:"docSurvey",query:{phase:phase}})
            },
            toInfo(){
                this.$router.push({path:"docInfo"})
            },
            toCase(exa){
                console.log(exa)
                // this.$toast("项目已结束")
                this.$router.push({name:"docCase",params:{star:this.star,exa:exa}})
            },
            toVideo(exa){
                console.log(exa)
                // this.$toast("项目已结束")
                this.$router.push({name:"docVideo",params:{exa:exa}})
                // this.$toast("项目已结束")
            },
            toGetPayStation(){
                this.dialogShow =true
                this.getPayStation(this.docId)
            },
            close(){
                this.dialogShow = false
            },
            async getStar(docId){
                const res = await ksdDocGetStar({docId})
                console.log(res.data.data,"star")
                this.star = res.data.data
                this.payTime = res.data.data.payTime
                if(this.payTime!=null&&this.payTime!=''){
                    this.payCompany="北京优迈迪科技有限公司"
                }
            },
            async getExaNumber(docId){
                const res = await ksdDocExaNumber({docId});
                this.exa = res.data.data.exaNumber
            },
            async getPayStation(docId){
                    const res = await ksdDocPayStation({docId});
                    this.payCompany = res.data.data.payCompany
                    this.payTime = res.data.data.payTime
                    console.log("payTime="+this.payTime);
            },
            async getExaStation(docId){
                const res = await ksdDocExaStation({docId});
                this.exaCaseName= res.data.data.caseStation
                this.exaVideoName = res.data.data.videoStation
                this.caseEnable = res.data.data.caseEnable
                this.videoEnable = res.data.data.videoEnable
                console.log(res.data.data)
            }
        },
        mounted(){
            if(this.$route.query.docId!=null){
                this.docId = this.$route.query.docId
                this.$store.state.ksd_docId = this.docId
            }
            this.getStar(this.docId)
            this.getExaNumber(this.docId)
            this.getExaStation(this.docId)
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        position: relative;
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .bottom{
        position: absolute;
        right: 0;
        bottom: -50px;
        img{
            width: 120px;
            height: 120px;
        }
    }
    .content{
        flex-grow: 1;
    }
    .content .rule{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-right: 15px;
        align-items: center;
        align-items: center;
        span{
            display: block;
            width: 16px;
            height: 16px;
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/question.png")  no-repeat ;
            background-size: contain;
            margin: 0 5px;
        }
    }
    .content .bar{
        width: 80%;
        margin: 0 auto;
        margin-top: 10px;
        border-radius: 5px;
        background: #2c9a58;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #FFF;
        padding: 3px 10px;
        opacity: 0.8;
        label{
            font-size: 22px;
            margin-left: 20px;
        }
        span{
            width: 1px;
            color: #FFF;
            height: 30px;
            background: #FFF;
        }
        img{
            width: 55px;
            height: 40px;
        }
    }
    .content .timeline{
        display: flex;
        flex-direction: column;
        /*margin: 0 auto;*/
        margin: 0 auto 50px auto;
        align-items: center;
        font-size: 16px;
        .item{
            text-align: left;
            width: 78%;
            height: 50px;
            border-left: 2px solid #2c9a58;
            position: relative;
            opacity: 0.8;
            color: #aaa;
            span{
                text-indent: 20px;
                position: absolute;
                bottom: -4px;
            }
            .dot{
                display: block;
                width: 12px;
                height: 12px;
                background: #2c9a58;
                border-radius: 50%;
                position: absolute;
                bottom: 0px;
                left: -7px;
                opacity: 0.8;
            }
            .btn{
                font-size: 10px;
                position: absolute;
                bottom: -4px;
                right: 10px;
                background: #aaa;
                border-radius: 5px;
                opacity: 0.8;
                color: #FFF;
                padding: 4px 15px;
            }
            .light{
                background: #2c9a58;
            }
        }
    }
    .pay{
        width: 80%;
        height: 350px;
        background: #FFF;
        position: absolute;
        top: 22%;
        left: 10%;
        right: 10%;
        border-radius: 30px;
        font-weight: bold;
        .close{
            text-align: right;
            margin: 15px 15px 0 0 ;
            img{
                width: 30px;
                height: 30px;
            }
        }
        .icon img{
                width: 150px;
                height: 130px;
        }
        .payStation{
            font-size: 25px;
            margin-top: 20px;
        }
        .payInfo{
            margin-top: 20px;
            text-align: left;
            font-size: 14px;
            margin-left: 30px;
            .line{
                margin-top: 10px;
                label{
                    margin-right: 20px;
                }
            }
        }
    }

    .highlight{
        color: #000;
        font-weight: bold;
    }


</style>
